function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 3)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C21313",
  d: "M7.755 17.591C11.918 13.55 14 9.974 14 6.865 14 3.074 10.866 0 7 0S0 3.074 0 6.865c0 3.109 2.082 6.684 6.245 10.726.42.408 1.09.408 1.51 0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 3,
  fill: "#FFF"
}));
function SvgPinRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}
export default SvgPinRed;